import React from "react";
import { NavbarCMS, ProgramsTable, } from "../../components";
import { useSelector } from "react-redux";

const ProgramCMS = () => {
    const setting = useSelector((state) => state?.combineReducer?.settings);
    return (
        <div className="h-full w-full">
            <NavbarCMS module={setting?.program_list?.navbar} />
            <ProgramsTable />
        </div>
    )
}

export default ProgramCMS;